import {NgModule} from '@angular/core'
import {CommonModule, NgOptimizedImage} from '@angular/common'
import {HomePageComponent} from './home-page.component'
import {HomePageContentModule} from '../../../shared/components/content/home-page-content/home-page-content.module'
import {TranslocoModule} from '@ngneat/transloco'
import {HomeBannerComponent} from './banner/home-banner.component'
import {HappinessDialogComponent} from './banner/happinees-dialog/happiness-dialog.component'
import {BrandingModule} from '../../../shared/components/branding/branding.module'
import {SellingPointBarModule} from '../../../craft/selling-point-bar/selling-point-bar.module'
import {WaveCoverImageModule} from '../../../craft/wave-cover-image/wave-cover-image.module'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {RouterModule} from '@angular/router'
import {ListModule} from '../../../craft/list/list.module'
import {BenefitComponent} from '../../../craft/benefit/benefit.component'
import {GoogleRatingComponent} from '../../../craft/google-rating/google-rating.component'
import {DialogModule} from '../../../craft/dialog/dialog.module'

@NgModule({
  declarations: [HomePageComponent, HomeBannerComponent, HappinessDialogComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    FontAwesomeModule,
    RouterModule,
    NgOptimizedImage,
    BrandingModule,
    SellingPointBarModule,
    WaveCoverImageModule,
    ListModule,
    BenefitComponent,
    GoogleRatingComponent,
    HomePageContentModule,
    DialogModule,
  ],
})
export class HomePageModule {}
